import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import NoResultFoundFilters from "../../../../atoms/noResultsFilters";
import { SelectedCards } from "../type";

const MultipleExperts = ({ selectedCards }: { selectedCards: SelectedCards[] }) => {

    return (
      <Grid container mt={"10px"}>
        {selectedCards.length ? (
          <Grid item xs={12}>
            <Typography
              sx={{
                fontSize: "0.8571428571428571rem",
                color: "rgba(0, 0, 0, 0.6)",
                mb: 1,
              }}
            >
              Selected Experts:
            </Typography>
            <TableContainer
              component={Paper}
              sx={{ borderRadius: 2, boxShadow: 1, mb: 3 }}
            >
              <Table
                size="small"
                sx={{
                  "& .MuiTableCell-root": {
                    borderRight: "1px solid #e0e0e0",
                    fontSize: 13,
                    maxWidth: 180,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: 44,
                  },
                  "& .MuiTableCell-root:last-child": {
                    borderRight: 0,
                  },
                  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
                    borderBottom: 0,
                  },
                  "& .MuiTableHead-root .MuiTableCell-root": {
                    fontWeight: 600,
                    fontSize: 14,
                    background: "#f5f5f5",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Expert Name</TableCell>
                    <TableCell>Relevant Company</TableCell>
                    <TableCell>Relevant Designation</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedCards.map((card, index) => (
                    <TableRow key={card.value} hover>
                      <TableCell sx={{ width: 40 }}>{index + 1}</TableCell>
                      <TableCell>{card.label}</TableCell>
                      <TableCell>{card.company}</TableCell>
                      <TableCell>{card.designation}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid item xs={12} mb="42px">
            <NoResultFoundFilters text="Please Select an Expert" />
          </Grid>
        )}
      </Grid>
    );
}

export default MultipleExperts